import { connect } from 'react-redux';

import {
  FullScreenControls,
  IFullScreenControlsCommonProps,
  IFullScreenControlsOwnProps,
} from '../../components/Fotorama/FullScreenControls';
import { IState } from '../../store';

export function mapStateToProps(state: IState) {
  return {
    village: state.villageData.village,
  };
}

export const FullScreenControlsContainer = connect<IFullScreenControlsCommonProps, IFullScreenControlsOwnProps>(
  mapStateToProps,
)(FullScreenControls);
